import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PlatformEventsPage from "@/pages/admin/PlatformEventsPage";

export const Route = createFileRoute("/_admin/admin/platform-events")({
  head: () => pageHead("Admin · Platform Events", "AKIVA admin · platform events portal.", "/admin/platform-events", true),
  component: PlatformEventsPage,
});
